import { Card } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";
import { useT } from "@/lib/i18n";
import { REVIEWS } from "@/lib/data";

export const Reviews = ({ lang }) => {
  const t = useT(lang);

  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative py-24 sm:py-32 bg-[#4a3520] text-[#f7f1e6]"
    >
      <div
        className="absolute inset-0 opacity-[0.07] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(rgba(247,232,201,0.6) 1px, transparent 1px)",
          backgroundSize: "18px 18px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#e8c875] mb-4">
            Google Reviews
          </div>
          <h2
            data-testid="reviews-heading"
            className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
          >
            {t.reviews.heading}
          </h2>
          <div className="mt-4 flex items-center gap-3 text-[#f0e3c7]">
            <div className="flex items-center gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star
                  key={i}
                  className="w-4 h-4 fill-[#e8c875] text-[#e8c875]"
                />
              ))}
            </div>
            <span className="text-sm">{t.reviews.sub}</span>
          </div>
        </div>

        <div
          data-testid="reviews-grid"
          className="columns-1 md:columns-2 lg:columns-3 gap-5 [column-fill:_balance]"
        >
          {REVIEWS.map((r, i) => (
            <Card
              key={r.name}
              data-testid={`review-card-${i}`}
              className="bg-[#5e4530] border-[#8a6a3f]/40 text-[#f7f1e6] p-6 rounded-2xl relative overflow-hidden hover:bg-[#6f5430] transition-colors"
            >
              <Quote className="absolute top-4 right-4 w-8 h-8 text-[#8a6a3f]/40" />
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: r.rating }).map((_, j) => (
                  <Star
                    key={j}
                    className="w-3.5 h-3.5 fill-[#e8c875] text-[#e8c875]"
                  />
                ))}
              </div>
              <p className="text-sm leading-relaxed text-[#f0e3c7] mb-5 whitespace-pre-line">
                "{lang === "ro" ? r.text_ro : r.text_en}"
              </p>
              <div className="flex items-center justify-between text-xs text-[#c9b58d]">
                <span className="font-medium">{r.name}</span>
                <span className="text-[#e8c875]">Google</span>
              </div>
            </Card>
          ))}
        </div>

        <div className="mt-12">
          <a
            data-testid="reviews-see-all"
            href="https://www.google.com/search?q=Skyline+Retreat+Matisesti+reviews"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 text-sm text-[#e8c875] hover:text-[#f7f1e6] border-b border-[#e8c875]/40 hover:border-[#f7f1e6] pb-0.5"
          >
            {t.reviews.seeAll} →
          </a>
        </div>
      </div>
    </section>
  );
};
